import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import CircularProgress from "@mui/material/CircularProgress";
import BaseDataChart, { BaseDataChartProps } from './BaseDataChart';

const DEFAULT_COLORS = [
    '#FFC400',
    '#FF3F7F',
    '#8C00FF',
    '#450693',
    '#008BFF',
    '#FF2DF1',
    '#00FF9C',
];

interface Props extends BaseDataChartProps {
    footer?: React.ReactNode;
}

const BarDataChart: React.FC<Props> = ({
                                           title,
                                           data,
                                           className,
                                           height = 380,
                                           width = 520,
                                           loading = false,
                                           footer,
                                       }) => {

    // BarDataChart.tsx - simplified renderChart
    const renderChart = () => {
        if (loading) return <CircularProgress />;

        const { data: chartData, groupings } = data;

        if (!chartData || Object.keys(chartData).length === 0) {
            return <div className="text-gray-400">Keine Daten vorhanden</div>;
        }

        const transformedData = Object.entries(chartData).map(([name, values]) => ({
            name: name.replace(/_/g, " "),
            ...values,
        }));

        // Single category = simple bar, multiple = stacked
        const isStacked = groupings.length > 1;

        return (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={transformedData} margin={{ left: 8, right: 8 }}>
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} width={32} />
                    <Tooltip cursor={false} />
                    {isStacked && <Legend />}
                    {groupings.map((grouping, index) => (
                        <Bar
                            key={grouping}
                            dataKey={grouping}
                            stackId={isStacked ? "a" : undefined}
                            fill={DEFAULT_COLORS[index % DEFAULT_COLORS.length]}
                            maxBarSize={50}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        );
    };

    return (
        <BaseDataChart
            title={title}
            data={data}
            className={className}
            height={height}
            width={width}
            loading={loading}
            footer={footer}
        >
            {renderChart()}
        </BaseDataChart>
    );
};

export default BarDataChart;